export interface Testimonial {
  name: string
  location: string
  meta: string
  quote: string
  avatar: string
}

/** Editable sample content. */
export const testimonials: Testimonial[] = [
  {
    name: 'Caroline M.',
    location: 'Portland, OR',
    meta: 'Started as a hobby',
    quote:
      'I had pressed flowers before and they always turned brown. The guide made me realize I was using the same method for every single flower. My second batch kept its color perfectly.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/390ee00a-1405-4ccc-9122-60846ab86842.jpg',
  },
  {
    name: 'Sylvia R.',
    location: 'Asheville, NC',
    meta: 'Sells her pieces',
    quote:
      'I started with bookmarks for friends and now I sell framed botanical art at local markets. Knowing what to gather in each season is what let me build stock before the holidays.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/7e6cef6d-9bd4-424a-99a9-f8c8a34ea3a3.jpg',
  },
  {
    name: 'Megan T.',
    location: 'Austin, TX',
    meta: 'Made it as a gift',
    quote:
      'I framed flowers from my grandmother’s garden for my mom. She cried. Nothing I have ever bought her came close.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/44a50293-94a9-4e57-87bd-86bdcd8cd792.jpg',
  },
  {
    name: 'Grace P.',
    location: 'Charleston, SC',
    meta: 'Lifelong gardener',
    quote:
      'I have grown flowers for thirty years and still learned things I did not know: what time of day to cut, and which blooms will never press well no matter what you do.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/025d2483-9942-45f0-b998-0c08de3df101.jpg',
  },
  {
    name: 'Julia A.',
    location: 'Denver, CO',
    meta: 'First time crafting',
    quote:
      'I am the type to start projects and never finish them. This time I finished the first one in an afternoon, and that made me want to keep going.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/2cbb4af6-e9fd-4fe7-b7bc-057e793777f2.jpg',
  },
  {
    name: 'Rachel L.',
    location: 'San Diego, CA',
    meta: 'Extra income',
    quote:
      'The pressed flower pendants basically sell themselves on Instagram. My material cost is tiny compared to what people happily pay.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/434ef63d-7a44-4b38-a263-7c1158aa9ccc.jpg',
  },
  {
    name: 'Anna C.',
    location: 'Madison, WI',
    meta: 'Wanted to unplug',
    quote:
      'I spend an hour on Sunday arranging petals and think about nothing else. It is the closest thing to meditating I have managed in years.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/26210bc9-3cf4-4d73-85e5-856a308ad67e.jpg',
  },
]
